// TODO: Import from @vayufp/coast-widget-sdk once available on npm.
// For now, this is a direct copy from widget-sdk/src/types/messages.ts

export const MESSAGE_TYPES = {
  LOADED: 'COAST_LOADED',
  LOGOUT: 'COAST_LOGOUT',
} as const;

export type CoastLoadedMessage = {
  type: typeof MESSAGE_TYPES.LOADED;
};

export type CoastLogoutMessage = {
  type: typeof MESSAGE_TYPES.LOGOUT;
};

export type CoastMessage = CoastLoadedMessage | CoastLogoutMessage;
